import { Vertical } from '@/types/verticals'

const redeemRoutes = (app: Vertical) => [
  {
    path: 'redeem/:step?',
    component: () => import('@/pages/redemption-page.vue'),
    name: `${app}-redeem`,
    meta: {
      preAuthRoute: true,
    },
  },
  {
    path: 'redeem/success/:product',
    component: () => import('@/pages/redeem-success.vue'),
    name: `redeem-success-${app}`,
  },
]

export const offroadRedeemRoutes = redeemRoutes(Vertical.Offroad)
export const backcountryRedeemRoutes = redeemRoutes(Vertical.Backcountry)
export const huntRedeemRoutes = redeemRoutes(Vertical.Hunt)
export const fishRedeemRoutes = redeemRoutes(Vertical.Fish)
